// Client-generated ID helpers. All produce alphanumeric-only strings (base36
// timestamp + random suffix), which matters for XSS review: these values are
// safe to interpolate into inline-attribute contexts without escaping
// (see REFACTOR_SECURITY_REPORT.md §3.8). Extracted verbatim from
// public/index.html's inline script (Phase 2 modularization).
export function pid() {
  return 'p' + Math.random().toString(36).slice(2, 9);
}

export function uid() {
  return 'o' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
}

export function iid() {
  return 'i' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
}

export function txid() {
  return 'txn_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
}
